/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { throwError } from "rxjs";
import { of } from "rxjs";
import { map } from "rxjs/operators";
import { catchError } from "rxjs/operators";
import { retry } from "rxjs/operators";
import { LoadingController } from "@ionic/angular";
import { ToastController } from "@ionic/angular";
import { AlertController } from "@ionic/angular";
import { HttpHeaders } from "@angular/common/http";



@Injectable({
	providedIn: "root"
})

export class PostsService {
	
	constructor(
		public httpClient: HttpClient,
		public loadingController: LoadingController,
		public toastController: ToastController,
		public alertController: AlertController,
		private storage: Storage,
		public translateService: TranslateService
	){



	}


	
	wpUrl: string = "https://www.boqueixon.gal";
	loading: any ;
	connectionLost: string = `Conexion perdida :-(`;
	
	/**
	* PostsService:getPosts(query)
	**/
	getPosts(query): Observable<any>{
		this.presentLoading(`Por favor, espere..`);
		let param = this.httpBuildQuery(query);
		return this.httpClient.get(this.wpUrl + `/wp-json/wp/v2/posts/?${param}&_embed`)
			.pipe(
				map(results => {
					console.log("RAW:",results);
					this.dismissLoading();
					//this.showToast("Successfully!");
					return results;
				}),
				catchError(err => {
					console.log("throwError:", err);
					if(err.error.message){
						this.showToast(err.error.message);
					}else{
						this.showAlert(err.statusText,`Aviso`,this.connectionLost);
					}
					return throwError(err);
				}),
				catchError(err => {
					console.log("reThrown:", err);
					return of([]);
				})
			);
	}
	
	
	/**
	* PostsService:getPost()
	**/
	getPost(postId:string): Observable<any>{
		this.presentLoading(`Cargando datos...`);
		return this.httpClient.get(this.wpUrl + `/wp-json/wp/v2/posts/${postId}?_embed=true`)
			.pipe(
				map(results => {
					console.log("RAW:","posts",results);
					this.dismissLoading();
					//this.showToast("Successfully!");
					return results;
				}),
				catchError(err => {
					console.log("throwError:", err);
					if(err.error.message){
						this.showToast(err.error.message);
					}else{
						this.showAlert(err.statusText,`Aviso`,this.connectionLost);
					}
					return throwError(err);
				}),
				catchError(err => {
					console.log("reThrown:", err);
					return of([]);
				})
			);
	}
	
	
	/**
	* PostsService:httpBuildQuery(obj)
	* @param object $obj
	**/
	private httpBuildQuery(obj) {
		let k, str;
		str = [];
		for (k in obj) {
			str.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
		}
		return str.join("&");
	}
	
	
	/**
	* PostsService:presentLoading()
	**/
	async presentLoading(message:string) {
		this.loading = await this.loadingController.create({
			message: message,
			spinner: "crescent",
			duration: 2000
		});
		await this.loading.present();
	}
	
	/**
	* PostsService:dismissLoading()
	**/
	async dismissLoading() {
		if(this.loading){
			await this.loading.dismiss();
		}
	}
	
	/**
	* PostsService:showToast($message)
	**/
	async showToast(message: string){
		const toast = await this.toastController.create({
			message: message,
			position: "bottom",
			color: "light",
			duration: 300
		});
		await toast.present();
	}
	
	
	/**
	* PostsService:showAlert()
	**/
	async showAlert(header:string, subheader: string, message: string){
		const alert = await this.alertController.create({
			header: header,
			subHeader: subheader,
			message: message,
			buttons: ["OK"]
		});
		await alert.present();
	}
	



}

